<div class="auth-container">
  <div class="row auth-main">
    <div class="col-sm-6 px-0 d-none d-sm-block">
      <div class="left-img" style="background-image: url(assets/images/pages/bg-05.png);">
      </div>
    </div>
    <div class="col-sm-6 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <form>
            <span class="error-header p-b-45">
              500
            </span>
            <span class="error-subheader2 p-b-5">
              Oops, Something went wrong. Please try after some times.
            </span>
            <div class="container-auth-form-btn mt-5">
              <button class="auth-form-btn" color="primary" mat-flat-button type="submit">
                Go To Home Page
              </button>
            </div>
            <div class="w-full p-t-15 p-b-15 text-center">
              <div>
                <a class="txt1" routerLink="/authentication/signin">
                  Need Help?
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
